export type PromoImageProps = {
  [partnerName: string]: {
    logoPath: string;
    logoAlt: string;
    logoHeight?: string;
    isHiddenOnStickyHeader?: boolean;
  };
};

/**
 * Dictionary that maps promotional path to associated image
 * Keys should be lowercase paths with no trailing slash
 */
export const PROMOTIONAL_PATH_TO_IMAGE_MAP: PromoImageProps = {
  allina: {
    logoPath: '/public/allina-health.svg',
    logoAlt: 'Allina Health',
    logoHeight: '15px',
  },
  cca: {
    logoPath: '/public/cca_logo.png',
    logoAlt: 'Commonwealth Care',
    logoHeight: '32px',
  },
  cigna: {
    logoPath: '/public/ESI-Logo@2x.png',
    logoAlt: 'Express Scripts Pharmacy',
    logoHeight: '32px',
    isHiddenOnStickyHeader: true,
  },
  flexdelivery: {
    logoPath: '/public/ESI-Logo@2x.png',
    logoAlt: 'Express Scripts Pharmacy',
    logoHeight: '32px',
    isHiddenOnStickyHeader: true,
  },
  devoted: {
    logoPath: '/public/devoted-health-inc-logo-white.svg',
    logoAlt: 'Devoted Health',
    logoHeight: '200px',
    isHiddenOnStickyHeader: true,
  },
};
